import {
  CHECK_INVITE_ELIGIBILITY_REQUEST,
  CHECK_INVITE_ELIGIBILITY_SUCCESS,
  CHECK_INVITE_ELIGIBILITY_FAILURE,
  VERIFY_INVITE_CODE_REQUEST,
  VERIFY_INVITE_CODE_SUCCESS,
  VERIFY_INVITE_CODE_FAILURE,
  RESET_INVITE_STATE
} from '../actions/inviteActions';

const initialState = {
  // 资格检查相关
  eligibilityChecking: false,
  eligibilityChecked: false,
  eligible: false,
  eligibilityError: null,
  userInfo: null,
  
  // 邀请码验证相关
  verifying: false,
  verifySuccess: false,
  verifyError: null,
  verifyResult: null,
  
  // 通用状态
  loading: false,
  error: null
};

const inviteReducer = (state = initialState, action) => {
  switch (action.type) {
    // 检查邀请码资格
    case CHECK_INVITE_ELIGIBILITY_REQUEST:
      return {
        ...state,
        eligibilityChecking: true,
        eligibilityError: null,
        loading: true,
        error: null
      };
    
    case CHECK_INVITE_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        eligibilityChecking: false,
        eligibilityChecked: true,
        eligible: action.payload.eligible || false,
        userInfo: action.payload.userInfo || null,
        eligibilityError: null,
        loading: false,
        error: null
      };
    
    case CHECK_INVITE_ELIGIBILITY_FAILURE:
      return {
        ...state,
        eligibilityChecking: false,
        eligibilityChecked: true,
        eligible: false,
        userInfo: null,
        eligibilityError: action.payload,
        loading: false,
        error: action.payload
      };
    
    // 验证邀请码
    case VERIFY_INVITE_CODE_REQUEST:
      return {
        ...state,
        verifying: true,
        verifySuccess: false,
        verifyError: null,
        verifyResult: null,
        loading: true,
        error: null
      };
    
    case VERIFY_INVITE_CODE_SUCCESS:
      return {
        ...state,
        verifying: false,
        verifySuccess: true,
        verifyError: null,
        verifyResult: action.payload,
        loading: false,
        error: null,
        // 验证成功后，用户就不再符合填写邀请码的条件了
        eligible: false,
        eligibilityChecked: true
      };
    
    case VERIFY_INVITE_CODE_FAILURE:
      return {
        ...state,
        verifying: false,
        verifySuccess: false,
        verifyError: action.payload,
        verifyResult: null,
        loading: false,
        error: action.payload
      };
    
    // 重置状态
    case RESET_INVITE_STATE:
      return {
        ...initialState
      };
    
    default:
      return state;
  }
};

export default inviteReducer; 